import styled from 'styled-components';

export const Price = styled.span`
  font-size: 0.825rem;
  padding: 0 0.5rem;
`;
